import { CASRoutingGroups } from '../../../cimsPage/instances/cas'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const routingGroups = CreateViewEditSoftRemoveRestore({
  object: 'Routing Group',
  page: CASRoutingGroups,
  create: '00244175-E44D-4823-8071-CB9B8F12FF6A',
  view: '9358C3EE-7AD6-4704-B6AA-8E6F3C15CB43',
  edit: '7FD4C469-4DB6-4157-884B-785A03A5F4C0',
  removeRestore: 'B21F44A3-3BD1-4253-B63B-9D2911534FBC',
})

export const CreateCASRoutingGroup = routingGroups.Create
export const ViewCASRoutingGroup = routingGroups.View
export const EditCASRoutingGroup = routingGroups.Edit
export const RemoveRestoreCASRoutingGroup = routingGroups.RemoveRestore

export type CASRoutingGroupPermission =
  | typeof CreateCASRoutingGroup
  | typeof ViewCASRoutingGroup
  | typeof EditCASRoutingGroup
  | typeof RemoveRestoreCASRoutingGroup
